module.exports = __webpack_public_path__ + "img/award-2.5a16552e.png";